'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var TRANSLATION_CHANGE_LANGUAGE_SUCCESS = exports.TRANSLATION_CHANGE_LANGUAGE_SUCCESS = 'TRANSLATION_CHANGE_LANGUAGE';
var TRANSLATION_REGISTER_SUCCESS = exports.TRANSLATION_REGISTER_SUCCESS = 'TRANSLATION_REGISTER';
var TRANSLATION_SET_AVAILABLE_LANGUAGES_SUCCESS = exports.TRANSLATION_SET_AVAILABLE_LANGUAGES_SUCCESS = 'TRANSLATION_SET_AVAILABLE_LANGUAGES';

var translation_register_success = exports.translation_register_success = function translation_register_success(trPath, trData) {
    return {
        type: TRANSLATION_REGISTER_SUCCESS,
        payload: {
            path: trPath,
            data: trData
        }
    };
};

var translation_register = exports.translation_register = function translation_register(trPath, trData) {
    return function (dispatch, getState) {
        return new Promise(function (resolve, reject) {
            dispatch(translation_register_success(trPath, trData));
            resolve();
        });
    };
};

var translation_set_available_languages_success = exports.translation_set_available_languages_success = function translation_set_available_languages_success(listLC) {
    return {
        type: TRANSLATION_SET_AVAILABLE_LANGUAGES_SUCCESS,
        listLC: listLC
    };
};

var translation_set_available_languages = exports.translation_set_available_languages = function translation_set_available_languages(listLC) {
    return function (dispatch, getState) {
        return new Promise(function (resolve, reject) {
            dispatch(translation_set_available_languages_success(listLC));
            resolve();
        });
    };
};

var translation_change_language_success = exports.translation_change_language_success = function translation_change_language_success(LC) {
    return {
        type: TRANSLATION_CHANGE_LANGUAGE_SUCCESS,
        LC: LC
    };
};

var translation_change_language = exports.translation_change_language = function translation_change_language(LC) {
    return function (dispatch, getState) {
        return new Promise(function (resolve, reject) {
            dispatch(translation_change_language_success(LC));
            resolve();
        });
    };
};